import { render, staticRenderFns } from "./ActivitiesTableHint.vue?vue&type=template&id=6461aa6c&scoped=true&"
import script from "./ActivitiesTableHint.vue?vue&type=script&lang=js&"
export * from "./ActivitiesTableHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6461aa6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VTextarea})
